import { installBreadcrumbListeners } from './breadcrumbs';
import { installConsolePatches } from './consoleLog';
import { captureFrontendError } from './capture';

let booted = false;

export async function bootObservability(): Promise<void> {
  if (booted) return;
  booted = true;

  installBreadcrumbListeners();
  installConsolePatches();

  window.addEventListener('error', (evt) => {
    captureFrontendError(evt.error ?? new Error(evt.message), {
      route: window.location.pathname,
    });
  });

  window.addEventListener('unhandledrejection', (evt) => {
    captureFrontendError(evt.reason ?? new Error('Unhandled promise rejection'), {
      route: window.location.pathname,
    });
  });
}

export { captureFrontendError } from './capture';
export { addManualBreadcrumb } from './breadcrumbs';
export {
  TRACE_ID_HEADER,
  SESSION_ID_HEADER,
  generateTraceId,
  getOrCreateSessionId,
} from './traceIds';
export { pushNetworkLog } from './networkLog';
